<template>
    <div class="mb-3">
        <div class="text-center py-2 alert alert-success">
          You have <b>{{days_left}}</b> free trial days left
      </div>
    </div>
</template> 

<script>

export default {
  
props: ['days_left'],

};
</script>